import { render, staticRenderFns } from "./PerformsAreaReportComponent.vue?vue&type=template&id=629ae279&scoped=true"
import script from "./PerformsAreaReportComponent.vue?vue&type=script&lang=js"
export * from "./PerformsAreaReportComponent.vue?vue&type=script&lang=js"
import style0 from "./PerformsAreaReportComponent.vue?vue&type=style&index=0&id=629ae279&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629ae279",
  null
  
)

export default component.exports